import { render, staticRenderFns } from "./ProvinceCombo.vue?vue&type=template&id=528aea8a&"
import script from "./ProvinceCombo.vue?vue&type=script&lang=js&"
export * from "./ProvinceCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports